export enum Types {
	ATUALIZAR_CIDADAO_AUTISTA_REQUEST = '@iirgd/ATUALIZAR_CIDADAO_AUTISTA_REQUEST',
	ATUALIZAR_CIDADAO_AUTISTA_SUCCESS = '@iirgd/ATUALIZAR_CIDADAO_AUTISTA_SUCCESS',
	ATUALIZAR_CIDADAO_AUTISTA_FAILURE = '@iirgd/ATUALIZAR_CIDADAO_AUTISTA_FAILURE',
	ATUALIZAR_CIDADAO_AUTISTA_CLEAR = '@iirgd/ATUALIZAR_CIDADAO_AUTISTA_CLEAR',
}

export interface AtualizarCidadaoAutista {
	data: AtualizarCidadaoAutistaData | null;
	status: number;
}

export interface AtualizarCidadaoAutistaRequest {
	header: {
		usuario: string;
		senha: string;
	};
	requestData: {
		numeroRg: string;
		digitoRg: string;
		ciptea: boolean;
		dataValidade: string | null;
		responsavel: {
			cpf: string;
			nome: string;
			logradouro: string;
			logradouroNumero: string;
			logradouroComplemento: string;
			logradouroBairro: string;
			logradouroCEP: string;
			logradouroMunicipioCodigo: string;
			logradouroMunicipioDigito: string;
			emailUsuario: string;
			emailDominio: string;
			telefoneDDD: string;
			telefoneNumero: string;
		};
	};
}

export interface AtualizarCidadaoAutistaData {
	numeroRg: string;
	digitoRg: string;
	nome: string;
	dataNascimento: string;
	ciptea: boolean;
	dataValidade: string;
	responsavel: {
		cpf: string;
		nome: string;
		logradouro: string;
		logradouroNumero: string;
		logradouroComplemento: string;
		logradouroBairro: string;
		logradouroCEP: string;
		logradouroMunicipioCodigo: string;
		logradouroMunicipioDigito: string;
		emailUsuario: string;
		emailDominio: string;
		telefoneDDD: string;
		telefoneNumero: string;
	};
}
